// extracted by mini-css-extract-plugin
module.exports = {"Container":"menu-select-section_Container__etT7Y"};